module.exports = __webpack_public_path__ + "static/media/DocsMultipleTagged.8fbfcaa6.svg";